<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <div
          v-if="
            permissions &&
            permissions.includes(roles.DESBLOQUEAR_AJUIZAMENTO) &&
            card.readOnly
          "
        >
          <DefaultButton
            :onClick="() => unblockAjuizamento(card)"
            btnVariant="btn-danger"
            icon="fas fa-user-times"
            text="Desbloquear Ajuizamento"
            class="m-2"
            style="padding-right: 52%"
          />
        </div>
        <div v-if="ajuizamentos && ajuizamentos.length > 0">
          <b-form-checkbox
            v-model="showConcluded"
            switch
            :value="true"
            :unchecked-value="false"
            class="d-flex justify-content align-items-center"
            style="margin-left: 1rem; margin-bottom: 1rem"
            size="md"
          >
            <span
              class="ml-1"
              style="font-size: 1.1em"
              >Ajuizamentos Concluídos</span
            >
          </b-form-checkbox>
          <div
            v-if="filteredAjuizamentos.length === 0"
            class="text-center p-3 my-3 border rounded bg-light"
          >
            <p class="mb-0">
              {{
                showConcluded
                  ? 'Este card não possui ajuizamentos concluídos no momento.'
                  : 'Este card não possui ajuizamentos em andamento no momento.'
              }}
            </p>
          </div>

          <b-tabs
            v-else
            vertical
            content-class="no-border"
            pills
            style="border: solid 1px #efefef; border-radius: 5px"
          >
            <div>
              <b-tab
                v-for="(obj, index) in filteredAjuizamentos"
                :key="index"
                :title="(index + 1).toString()"
                class="no-border"
              >
                <div
                  class="form-group row pr-3 pb-4"
                  style="
                    float: right;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                  "
                  v-if="!card.boardColumn.board.isReadOnly"
                >
                  <span
                    class="pointer"
                    @click="deleteAjuizamento(obj)"
                    v-if="!showConcluded"
                    title="Excluir Ajuizamento"
                  >
                    <i
                      class="fa fa-trash"
                      style="font-size: 1.2em; color: #dc3545"
                    ></i>
                  </span>
                  <span
                    class="pointer"
                    @click="editAjuizamento(obj)"
                    v-if="!showConcluded"
                  >
                    <i
                      class="fa fa-pen"
                      style="font-size: 1.2em"
                    ></i>
                  </span>
                  <span
                    class="pointer"
                    @click="changeCompleteStatus(obj)"
                  >
                    <i
                      :class="
                        showConcluded
                          ? 'fa fa-times-circle'
                          : 'fa fa-check-circle'
                      "
                      :title="
                        showConcluded
                          ? 'Reabrir Ajuizamento'
                          : 'Concluir Ajuizamento'
                      "
                      style="font-size: 1.2em"
                    >
                    </i>
                  </span>
                </div>
                <div class="form-group row pt-4">
                  <div class="col-md-12 d-flex align-items-center">
                    <label
                      for="linkmove"
                      class="mt-3"
                    >
                      <strong>Status: &nbsp;</strong>
                    </label>
                    <DefaultButton
                      :onClick="openMoveCardModal"
                      id="linkmove"
                      :text="obj.status"
                      class="pb-3"
                      textColor="#04A791"
                      btnVariant="btn btn-link text-decoration-underline border-0 hover-link"
                      style="display: inline-block"
                    />
                  </div>
                  <div class="col-md-12">
                    <label><strong>Nº do Processo: &nbsp;</strong></label>
                    {{ obj.numeroProcesso }}
                  </div>
                  <div class="col-md-12">
                    <label><strong>Instância: &nbsp;</strong></label>
                    {{ getInstanciaText(obj) }}
                  </div>
                  <div class="col-md-12 input-group">
                    <label>
                      <strong>Assunto: &nbsp;</strong>
                      <TextTruncate :text="obj.assunto && obj.assunto.nome" />
                    </label>
                  </div>
                  <div class="col-md-12 input-group">
                    <label>
                      <strong>Objeto da Ação: &nbsp;</strong>
                      <TextTruncate
                        :text="obj.objetoAcao && obj.objetoAcao.nome"
                      />
                    </label>
                  </div>
                  <div class="col-md-12 input-group">
                    <label>
                      <strong>Comarca: &nbsp;</strong>
                      <TextTruncate :text="obj.comarca && obj.comarca.nome" />
                    </label>
                  </div>
                  <div class="col-md-12 input-group">
                    <label>
                      <strong>Advogado Responsável: &nbsp;</strong>
                      <TextTruncate :text="obj.advogadoResponsavel.nome" />
                    </label>
                  </div>
                  <div class="col-md-12 input-group">
                    <label>
                      <strong>Advogado Contrário: &nbsp;</strong>
                      <TextTruncate :text="(obj.advogadoContrario && obj.advogadoContrario.nome) || 'Não informado'" />
                    </label>
                  </div>
                  <div class="col-md-12 input-group">
                    <label>
                      <strong>Prognóstico: &nbsp;</strong>
                      <TextTruncate
                        :text="obj.prognostico && obj.prognostico.nome"
                      />
                    </label>
                  </div>
                  <div class="col-md-12">
                    <div class="input-group">
                      <label><strong>Valor Causa: &nbsp;</strong></label>
                      {{
                        obj.valorCausa.toLocaleString('pt-Br', {
                          style: 'currency',
                          currency: 'BRL'
                        })
                      }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="input-group">
                      <label><strong>Valor Causa 2: &nbsp;</strong></label>
                      {{
                        obj.valorCausa2
                          ? obj.valorCausa2.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL'
                            })
                          : 'Não informado'
                      }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="input-group">
                      <label><strong>Data Distribuição: &nbsp;</strong></label>
                      {{
                        obj.dataDistribuicao && formatDate(obj.dataDistribuicao)
                      }}
                    </div>
                  </div>
                  <div class="col-md-12 input-group">
                    <label>
                      <strong>Fase: &nbsp;</strong>
                      <TextTruncate :text="obj.fase && obj.fase.nome" />
                    </label>
                  </div>
                  <div class="col-md-12">
                    <div class="input-group">
                      <label><strong>Último Andamento: &nbsp;</strong></label>
                      {{
                        obj.ultimoAndamento && formatDate(obj.ultimoAndamento)
                      }}
                    </div>
                  </div>
                </div>
              </b-tab>
            </div>
          </b-tabs>
        </div>
        <div v-else>
          Nenhum registro encontrado.
          <strong
            v-if="cardActive"
            @click="addAjuizamento"
            style="cursor: pointer"
            >Clique para adicionar</strong
          >
        </div>
      </div>
    </div>
    <ModalAjuizamento
      ref="ModalAjuizamento"
      :card="card"
      :person="person"
      :ajuizamento="ajuizamento"
      @Reload="onReload"
    />
    <MoveCardPopover
      v-if="card && openMoveCardComponent"
      :idCurrentBoard="card.boardColumn.id"
      :card="card"
      :bondId="'linkmove'"
      @moved="movedCard"
      @close="openMoveCardComponent = false"
      ref="moveCardPopover"
    />
  </div>
</template>
<script>
import CrmDetailsAjuizamento from './ajuizamento.js'

export default CrmDetailsAjuizamento
</script>
<style lang="scss">
.nav.nav-pills {
  li.nav-item {
    margin-bottom: 0.2rem;
  }
}
</style>
<style scoped>
.no-border {
  border: 0px;
}
</style>
<style>
.hover-link:hover {
  color: #04a791;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/ajuizamento/ajuizamento.vue